import { ProductsListItem } from "modules/products";
import { ProductSetsListItem } from "modules/productSets";
import * as yup from "yup";

import { FeedInsertWidth, FeedInsertType } from "../../constants";
import { FeedInsertMediaItem } from "../../content.types";

export const feedInsertValidationSchema = yup
  .object({
    id: yup.string().optional(),
    name: yup
      .string()
      .required("Name is required")
      .min(3, "Field must be at least 3 characters long"),
    form: yup
      .mixed<FeedInsertWidth>()
      .oneOf(Object.values(FeedInsertWidth))
      .required("Form is required"),
    type: yup
      .mixed<FeedInsertType>()
      .oneOf(Object.values(FeedInsertType))
      .required("Type is required"),
    header: yup
      .string()
      .notRequired()
      .nullable()
      .transform((v) => (v === "" ? null : v)),
    text: yup
      .string()
      .notRequired()
      .nullable()
      .transform((v) => (v === "" ? null : v)),
    spaceBeforeSliderStart: yup
      .number()
      .notRequired()
      .nullable()
      .positive("Should be positive")
      .min(0, "Should be greater than 0")
      .max(100, "Should be less than 100"),
    media: yup
      .array<FeedInsertMediaItem[]>(yup.object())
      .when("type", {
        is: (val: FeedInsertType) => val === FeedInsertType.SingleMedia,
        then: (schema) =>
          schema.required().min(1, "At least one media must be added"),
        otherwise: (schema) => schema.notRequired().min(0)
      })
      .when("type", {
        is: (val: FeedInsertType) => val === FeedInsertType.MultipleMedia,
        then: (schema) =>
          schema.required().min(2, "At least 2 media must be added"),
        otherwise: (schema) => schema.notRequired().min(0)
      }),
    products: yup.array<ProductsListItem[]>(yup.object()).when("type", {
      is: (val: FeedInsertType) => val === FeedInsertType.Products,
      then: (schema) => schema.notRequired().min(0),
      otherwise: (schema) => schema.notRequired().min(0)
    }),
    productSet: yup
      .object<ProductSetsListItem>()
      .nullable()
      .when("type", {
        is: (val: FeedInsertType) => val === FeedInsertType.Products,
        then: (schema) => schema.notRequired().nullable(),
        otherwise: (schema) => schema.notRequired().nullable()
      })
  })
  .test(
    "products-or-productSet",
    "Either select at least 3 products or choose a product set",
    function (value) {
      const { type, products, productSet } = value;
      if (type !== FeedInsertType.Products) {
        return true;
      }

      const hasProducts = products && products.length >= 3;
      const hasProductSet = productSet && productSet !== null;

      if (!hasProducts && !hasProductSet) {
        return this.createError({
          path: "products",
          message: "Either select at least 3 products or choose a product set"
        });
      }

      return true;
    }
  );
